import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-882185ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-filter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Message Filter", -1))
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  key: 0,
  class: "filter-field"
}
const _hoisted_6 = {
  key: 1,
  class: "filter-field"
}
const _hoisted_7 = { class: "format-options" }
const _hoisted_8 = { class: "action-buttons" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: _normalizeClass({ tab: true, active: _ctx.activeTab === 'generate' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'generate'))
      }, " Generate Filter Query ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ tab: true, active: _ctx.activeTab === 'filter' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'filter'))
      }, " Filter Query ", 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.activeTab === 'generate')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.generateFilterPrompt) = $event)),
              placeholder: "Describe what the filter you want generated...",
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.autoResize && _ctx.autoResize(...args))),
              onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleKeyDown('generate', $event)))
            }, null, 544), [
              [_vModelText, _ctx.generateFilterPrompt]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'filter')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterFormat) = $event)),
                  value: "simple"
                }, null, 512), [
                  [_vModelRadio, _ctx.filterFormat]
                ]),
                _createTextVNode(" Simple ")
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterFormat) = $event)),
                  value: "mongo"
                }, null, 512), [
                  [_vModelRadio, _ctx.filterFormat]
                ]),
                _createTextVNode(" MongoQuery ")
              ])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterPrompt) = $event)),
              placeholder: "Enter your filter query here...",
              onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.autoResize && _ctx.autoResize(...args))),
              onKeydown: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleKeyDown('filter', $event)))
            }, null, 544), [
              [_vModelText, _ctx.filterPrompt]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.activeTab === 'generate')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.generateFilter && _ctx.generateFilter(...args))),
            disabled: _ctx.isGenerating
          }, _toDisplayString(_ctx.isGenerating ? 'Generating...' : 'Generate Filter'), 9, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'filter')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)))
          }, "Apply Filter"))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'filter')
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
          }, "Reset Filter"))
        : _createCommentVNode("", true)
    ])
  ]))
}